<div class="users-container">
    <app-form-row>
      <app-card-sm-container>
        <div class="user-count-container">
          <div>
                <app-label
                    [text]="'Total Medicines Count'">
                </app-label>
          </div>
          <div class="count-container">
            <label>{{medicinesCount}}</label>
          </div>
        </div>
      </app-card-sm-container>
    </app-form-row>

    <div class="button-container">
      <app-button [button]="createMedicinesButton">
      </app-button>

      <app-button [button]="getMedicinesButton">
      </app-button>
    </div>
</div>
